import { CardCodeForm } from '@/components/create/card/CardCodeForm';
import { CardFormVariant } from '@/types/card/CardFormVariant';
import { ClientDialog } from '@/components/common/modal/ClientDialog';
import { CreateCardForm } from '@/components/create/card/CreateCardForm';
import { Theme } from '@mui/material/styles';
import React, { FC } from 'react';

interface Props {
  open: boolean;
  variant: CardFormVariant;
  onClose?: () => void;
}

export const CardFormDialog: FC<Props> = (props: Props) => {
  const { open, variant, onClose } = props;
  const handleClose = (): void => {
    if (onClose) {
      onClose();
    }
  };
  return (
    <ClientDialog
      open={open}
      isMobile={true}
      label={variant === CardFormVariant.CREATED ? 'Оформить Ф-карту' : 'Пополнить баланс карты'}
      handleCloseButton={handleClose}
      sxContent={(theme: Theme) => ({
        marginTop: theme.spacing(-2),
        paddingBottom: theme.spacing(6 + 3),
      })}>
      {variant === CardFormVariant.CREATED ? <CreateCardForm isMobile={true} /> : <CardCodeForm isMobile={true} />}
    </ClientDialog>
  );
};
